export default __webpack_public_path__ + "assets/webgl/picking-5.69016fbe.glb";